import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="px-5 pb-10 pt-16 sm:px-8" data-testid="site-footer">
    <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
      <Logo testId="footer-logo" />
      <p className="text-sm text-[#5A6176]">© {new Date().getFullYear()} Otti.</p>
    </div>
  </footer>
);
